<template>
	<div class="sms-push">
		<Common-Shell type="smsPush" :search-option="searchOption"></Common-Shell>
	</div>
</template>

<script>
import CommonShell from '../comps/CommonShell.vue'
export default {
	name: 'smsPush',
	components: { CommonShell },
	props: {},
	data() {
		return {}
	},
	computed: {
		searchOption() {
			return {}
		},
	},
	watch: {},
	created() {},
	mounted() {},
	methods: {},
}
</script>
<style lang="scss" scoped>
.sms-push {
	height: 100%;
}
</style>
